import React, { useMemo } from "react";
import "./Terms.css";
import { useLocalContext } from "../../context/LocalContext";

const Terms = () => {
  const { webinfo = {} } = useLocalContext();

  const brand = useMemo(
    () => ({
      name: webinfo.name || "webantidigi.com",
      email: webinfo.email || "contact@webantidigi.com",
      phone: webinfo.phone || "+1 (000) 000-0000",
      phonecall: webinfo.phonecall || "+10000000000",
      address: webinfo.address || "United States",
    }),
    [webinfo]
  );

  const effectiveDate = useMemo(
    () =>
      new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
    []
  );

  return (
    <section className="terms">
      <div className="terms-wrap">
        <header className="terms-head">
          <span className="terms-kicker">Legal</span>
          <h1>Terms &amp; Conditions</h1>
          <p className="terms-meta">
            <span>Provider: {brand.name}</span>
            <span>Last updated: {effectiveDate}</span>
            <span>Applicable to: United States</span>
          </p>
        </header>

        <div className="terms-content">
          <TermsBlock title="1. Scope">
            <p>
              These Terms govern use of this website and purchases made through{" "}
              {brand.name}. By using the site, you agree to these Terms.
            </p>
          </TermsBlock>

          <TermsBlock title="2. Independent seller disclosure">
            <p>
              We are an independent service provider/reseller. Unless explicitly
              stated, we are not owned by, endorsed by, or officially affiliated
              with third-party brands shown on this site.
            </p>
          </TermsBlock>

          <TermsBlock title="3. Orders, pricing, and payments">
            <p>
              Pricing and availability may change before purchase. Final pricing is
              the amount shown at checkout. Payments are handled by third-party
              processors and may be subject to verification.
            </p>
          </TermsBlock>

          <TermsBlock title="4. Delivery and fulfillment">
            <p>
              For digital services/products, delivery is typically electronic and
              may vary based on verification, provider systems, and operational
              conditions.
            </p>
          </TermsBlock>

          <TermsBlock title="5. Refunds and cancellations">
            <p>
              Refund and cancellation terms are described in our Refund Policy.
              Some delivered digital items may be non-refundable except where
              required by law.
            </p>
          </TermsBlock>

          <TermsBlock title="6. Acceptable use">
            <p>
              You agree not to use this site for fraudulent, deceptive, abusive,
              or unlawful activities, including impersonation of brands or support
              channels.
            </p>
          </TermsBlock>

          <TermsBlock title="7. Transparency and ad policy standards">
            <p>
              We aim to follow U.S.-focused consumer transparency standards and
              major ad platform policy principles, including clear disclosures and
              non-misleading claims.
            </p>
          </TermsBlock>

          <TermsBlock title="8. Limitation of liability">
            <p>
              To the maximum extent allowed by law, services are provided "as is"
              and liability is limited to the amount paid for the relevant service
              or order.
            </p>
          </TermsBlock>

          <TermsBlock title="9. Contact">
            <ul className="terms-contact">
              <li>
                <strong>Email:</strong>{" "}
                <a href={`mailto:${brand.email}`}>{brand.email}</a>
              </li>
              <li>
                <strong>Phone:</strong>{" "}
                <a href={`tel:${brand.phonecall}`}>{brand.phone}</a>
              </li>
              <li>
                <strong>Address:</strong> {brand.address}
              </li>
            </ul>
          </TermsBlock>
        </div>
      </div>
    </section>
  );
};

const TermsBlock = ({ title, children }) => (
  <section className="terms-card">
    <h2>{title}</h2>
    {children}
  </section>
);

export default Terms;
